export const videos = [
  {
    _id: "qOpI7iw_mfo",
    title: "Triumph Daytona 675 | Pure Exhaust Sound [4K]",
    description:
      "RAW sound of the 2014 Triumph Daytona 675 on the beautiful roads of the Black Forest in Germany. Be sure to subscribe to the channel for more of these to come in the near future. Thanks!",
    creator: "GearedUp",
    creatorImage: "v1650781005/gearedup_rzyuph.jpg",
    category: "eargasm",
    thumbnail: "v1650782343/daytona_cmmass.webp",
    createdAt: 1588507896,
  },
  {
    _id: "zMectJQ9cWo",
    title: "Benelli 600i Pure INLINE 4 sound |High Revs",
    description:
      "Listen to High Quality Engine sound of BENELLI 600I.Enjoy the ride video.This video is made for entertainment purpose only.",
    creator: "raviKiran kasturi",
    creatorImage: "v1650781005/ravikiran_ltnudc.jpg",
    category: "eargasm",
    thumbnail: "v1650782342/benelli_gu77rr.webp",
    createdAt: 1592827896,
  },
  {
    _id: "YTOQHzQXKJY",
    title: "2020 Kawasaki Z900 sound [RAW Onboard]",
    description:
      "Ah yes! The Z900! That one bike which almost lets me forget I am not a big fan of inline-4s. Such a stunning nakedbike!",
    creator: "Schaaf",
    creatorImage: "v1650781005/schaaf_elsiks.jpg",
    category: "eargasm",
    thumbnail: "v1650782343/z900_shpizo.webp",
    createdAt: 1571746296,
  },
  {
    _id: "Hw22RbfSgww",
    title: "Ducati Streetfighter V4 S sound [RAW Onboard]",
    description:
      "Listen to the stock exhaust sound of a 2021 Ducati Streetfighter V4 S! This bike would deserve the title of beast! What an incredible machine! ",
    creator: "Schaaf",
    creatorImage: "v1650781005/schaaf_elsiks.jpg",
    category: "eargasm",
    thumbnail: "v1650782343/ducati_uumu5i.webp",
    createdAt: 1637669496,
  },
  {
    _id: "Wsjeq48t0Co",
    title: "Royal Enfield Scram 411 Detailed Review",
    description: "Royal Enfield Scram 411 Detailed Review",
    creator: "Strell",
    creatorImage: "v1650781005/strell_w2adiz.jpg",
    category: "review",
    thumbnail: "v1650782513/scram411_ibqjpt.webp",
    createdAt: 1648901496,
  },
  {
    _id: "E12v3_xgyKM",
    title: "Yamaha R15 V4 M Detailed Review",
    description: "Yamaha R15 V4 M Detailed Review",
    creator: "Strell",
    creatorImage: "v1650781005/strell_w2adiz.jpg",
    category: "review",
    thumbnail: "v1650782513/r15_fc1tfp.webp",
    createdAt: 1648812353,
  },
  {
    _id: "BGG4SKys01E",
    title: "Triumph Tiger 900 | An All-Rounder Adventure Bike",
    description:
      "Here is the most detailed review of the Triumph Tiger 900 GT I tell you everything about the design, cluster, features, performance, ride, handling, braking, price, and of course give you a verdict on whether you should buy a Triumph Tiger 900 GT in India. This Triumph Tiger 900 GT review is a long ride one with a real-world perspective of the adventure motorcycle from Triumph.",
    creator: "Faisal Khan",
    creatorImage: "v1650781004/faisal-khan_sy4fxe.jpg",
    category: "review",
    thumbnail: "v1650782513/tiger_bnmexe.webp",
    createdAt: 1617365496,
  },
  {
    _id: "wViSpn-GmMg",
    title: "Kawasaki ZX10R | Top Speed | First Ride Review",
    description:
      "hi guys, finally I get my hands on Kawasaki ZX10R - the Dominating Force from WSBK and Jonathan Rea's Weapon of Choice for 6 Consecutive Wins at WSBK. I share a complete overview and talk about my ride impression in my signature style motovlog.",
    creator: "Dino's Vault",
    creatorImage: "v1650781004/dino_hg1goz.jpg",
    category: "review",
    thumbnail: "v1650782513/zx10r_kptg4x.webp",
    createdAt: 1627906296,
  },
  {
    _id: "RSXoSFjWDu0",
    title: "Yamaha R6 Adrenaline Street Riding",
    description:
      "Be The Best Not The Fastest. Be the best not always means you are the fastest one. You should never ride beyond or even close to your limits.",
    creator: "SuperBike Racer",
    creatorImage: "v1650781006/superbike-racer_fudtfo.jpg",
    category: "adrenaline-rush",
    thumbnail: "v1650782170/r6_onvazp.webp",
    createdAt: 1586693496,
  },
  {
    _id: "SZqk-O-nkjo",
    title: "Kawasaki ZX6R Pure Sound of Adrenaline Rush",
    description:
      "Hi guys, another spontaneous vlog where I ride my friend's Kawasaki ZX6R on a Fine Sunday Morning and just instantly fall in love with the kind of insane acceleration and control and poise this machine has on offer. The legendary 636 engine sings gloriously as you and I get a glimpse of what makes this an Absolute Gem of an Engine from Kawasaki.",
    creator: "Dino's Vault",
    creatorImage: "v1650781004/dino_hg1goz.jpg",
    category: "adrenaline-rush",
    thumbnail: "v1650782170/zx6r_tqho0m.webp",
    createdAt: 1605528696,
  },
  {
    _id: "_Q7aFwYy9h0",
    title: "Pure Adrenaline Rush on Triumph Street Triple",
    description:
      "Pure Adrenaline Rush on Triumph Street Triple RS 765 | SC-Project Pure Triple Symphony",
    creator: "Triple Rush",
    creatorImage: "v1650781005/triple-rush_sl8gkw.jpg",
    category: "adrenaline-rush",
    thumbnail: "v1650782170/street-triple_ipozee.webp",
    createdAt: 1603627896,
  },
  {
    _id: "PoEMtsOtpg8",
    title: "Pure Adrenaline On Suzuki Gsx-R Fastest",
    description:
      "Taking a dose of pure adrenaline on my Suzuki Gsx-r 1000 K9 after an abstention of 2 months, i was a little bit cautious with my driving because of the street's cold temperature  and also of the street surface, in some places was wet.Video was shoot with GoPro Hero 4 Black and a Gyro Mount.",
    creator: "SuperBike Racer",
    creatorImage: "v1650781006/superbike-racer_fudtfo.jpg",
    category: "adrenaline-rush",
    thumbnail: "v1650782170/gsxr_j18afr.webp",
    createdAt: 1448453496,
  },
  {
    _id: "x63bh1_gg_M",
    title: "🇮🇲 Isle of Man TT TOP SPEED MOMENTS",
    description:
      "In this video you will see extremely fast motorcycle rides during the TT race on the Isle of Man. Many thanks to all motorcyclists and motorcycle fans who contributed their videos to our motorcycle channel.",
    creator: "martin Ward",
    creatorImage: "v1650781004/martin_h8zbmm.jpg",
    category: "isle-of-man",
    thumbnail: "v1650782432/isle-1_zzadq4.webp",
    createdAt: 1618488696,
  },
  {
    _id: "D3Ck0R1Ha_8",
    title: "2018 ISLE OF MAN TT TOP 10 REACTIONS",
    description:
      "Here is what I have stumbled across online for reactions of people watching the races over the TT period",
    creator: "TMVinyl",
    creatorImage: "v1650781005/tmvynil_frlcg7.jpg",
    category: "isle-of-man",
    thumbnail: "v1650782432/isle-2_b4sxpw.webp",
    createdAt: 1523794296,
  },
  {
    _id: "GFG4udGLXic",
    title: "Isle of Man TT - Best Moments, Highlights",
    description:
      "Welcome to our video showing the best fan footage/highlights of the Isle of Man TT in preparation of the 2019 Isle of Man TT. The Isle of Man TT, sometimes shortened to IOMTT, is the worlds most famous road racing event and one of the most popular motorsport spectacles. The Isle of Man TT features a variety of motorcycles including 1000cc superbikes an 600cc supersport bikes racing around the isle of man at crazy high speeds.",
    creator: "FTP Motorsport",
    creatorImage: "v1650781004/ftp_xoc2nt.jpg",
    category: "isle-of-man",
    thumbnail: "v1650782433/isle-3_olttom.webp",
    createdAt: 1555330296,
  },
  {
    _id: "5KzBnuxDnYQ",
    title: "AMAZING Isle of Man TT races!",
    description:
      "Featuring detailed telemetry showing throttle and brake behaviour and speed, plus guided commentary from rapid Aussie rider and two time TT winner Cameron Donald  as he takes us on a high speed tour of the famous mountain course aboard his 600cc Honda Supersport weapon!",
    creator: "iomtt",
    creatorImage: "v1650781004/iomtt_yy8jqv.jpg",
    category: "isle-of-man",
    thumbnail: "/v1650782433/isle-4_lfmxkn.webp",
    createdAt: 1492258296,
  },
];
